<template>
  <div class="content work_flow_wrap" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="tab-wrap">
        <el-tabs v-model="page.listType" @tab-click="getList">
          <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
          <el-tab-pane label="待处理" name="4"></el-tab-pane>
          <el-tab-pane label="已处理" name="2"></el-tab-pane>
          <el-tab-pane label="我收到的" name="3"></el-tab-pane>
          <el-tab-pane label="我发起的" name="1"></el-tab-pane>
        </el-tabs>
      </div>
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6"
          ><div class="search-area-div">审批状态：</div>
          <el-select  size="mini" filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">企业名称：</div>
          <el-select  size="mini" filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择" @change="getTableOrganisationList">
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">部门名称：</div>
          <el-select
            size="mini"
            v-model="page.organisationGuids"
            placeholder="请选择部门名称"
            class="ipt-sty"
            clearable
            filterable
            multiple
            collapse-tags
            @focus="getOrganisation(1)"
          >
            <el-option
              v-for="item in tableOrganisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
    
        <el-col :span="6">
          <el-button
            size="mini"
            type="text"
            @click="showMore = !showMore"
            :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
          >
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
        >
      </el-row>
      <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6"
          ><div class="search-area-div">核算月份：</div>
          <el-date-picker
            size="mini"
            v-model="page.accountMonth"
            class="ipt-sty"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">提交日期：</div>
          <el-date-picker
            size="mini"
            v-model="timeListS"
            type="daterange"
            range-separator="至"
            class="ipt-sty"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">流程编号：</div>
          <el-input v-model="page.flowNo" class="ipt-sty" placeholder="请输入" clearable></el-input>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">流程名称：</div>
          <el-select  size="mini" filterable clearable v-model="page.flowType" class="ipt-sty" placeholder="请选择">
            <el-option v-for="item in flowTypeOption" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row  :gutter="24" class="mt15" v-show="showMore" >
        <el-col :span="6"
          ><div class="search-area-div">发起人：</div>
          <el-select  size="mini"   multiple collapse-tags v-model="page.flowStaffGuids" class="ipt-sty"  placeholder="请选择发起人" filterable>
            <el-option v-for="item in staffList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">是否已对冲：</div>
          <el-select  size="mini" filterable multiple collapse-tags  v-model="page.isHedgeList" class="ipt-sty"  placeholder="请选择是否对冲" >
            <el-option
              v-for="item in trueOrFalseOptionII"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6"
          ><div class="search-area-div">服务商名称：</div>
          <el-select  size="mini" filterable clearable v-model="page.serviceTenantGuid" class="ipt-sty"  placeholder="请选择服务商名称" >
            <el-option
              v-for="item in allServiceTenantList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>

    </div>
    <div class="back-color-fff content-main-box"   :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="dialogFlow = true">流程审批申请</el-button>
      </div>
      <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="left"
          prop="flowNo"
          label="流程编号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.flowNo || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="flowName"
          label="流程名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
        </el-table-column>
        <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="100">
          <template slot-scope="scope"
            ><span :class="getStateShow(scope.row.isHedge == 'Y'?'C':scope.row.approveState)">{{
              scope.row.approveState | approveState
            }}</span></template
          >
        </el-table-column>
        <el-table-column
          prop="isHedge"
          label="是否已对冲"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
          <template slot-scope="scope">{{ scope.row.isHedge == 'Y' ? '已对冲' : scope.row.isHedge == 'N'?'未对冲':'-' }}</template>
        </el-table-column>
        <el-table-column prop="staffName" label="提交人" header-align="center" align="left" width="120">
          <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="planName"
          label="是否开票"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
        <template slot-scope="scope">{{ scope.row.isApplyInvoice == 'Y' ? '是' : scope.row.isApplyInvoice == 'N'?'否':'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="bizTenantName"
          label="药企名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="bizOrganisationName"
          label="组织名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="serviceTenantName"
          label="服务商名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="180"
        >
          <template slot-scope="scope">{{ scope.row.serviceTenantName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="accountMonthName"
          label="核算月份"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="billCycleList"
          label="账单周期"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
          <template slot-scope="scope">{{ scope.row.billCycleList | billFilter  }}</template>
        </el-table-column>
        <el-table-column
          prop="taskTitleName"
          label="任务包名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="140"
        >
          <template slot-scope="scope">{{ scope.row.taskTitleName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          label="任务金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.taskSumAmount | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="serviceFeeRate"
          label="服务费率"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="100"
        >
          <template slot-scope="scope">{{ (scope.row.serviceFeeRate || 0) + '%' }}</template>
        </el-table-column>
        <el-table-column
          prop="serviceFee"
          label="服务费(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.serviceFee | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="currentPayAmount"
          label="应付/开票金额(元)"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
          :renderHeader="renderHeader"
        >
          <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
        </el-table-column>
        <el-table-column
          prop="comprehensiveGrade"
          label="打分"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ scope.row.comprehensiveGrade ? getComprehensiveGrade(scope.row) : '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="提交时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="140"
        >
          <template slot-scope="scope">{{ scope.row.createTime | getTime }}</template>
        </el-table-column>
        <el-table-column prop="approveTime" label="操作时间" header-align="center" align="left" width="140">
          <template slot-scope="scope">{{ scope.row.approveTime | getTime }}</template>
        </el-table-column>
        <el-table-column
          prop="planName"
          label="是否已开票"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
          <template slot-scope="scope">{{ scope.row.isInvoiced == 'Y' ? '是' : '否' }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a
              class="txt-color"
              v-if="getListBtnState('detail', scope.row) == 'detail'"
              @click="editData(scope.row, 2)"
            >
              详情
            </a>
            <a
              class="txt-color"
              @click="passDialogClick(scope.row)"
              v-if="scope.row.flowType!='00016'&&getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
               @click="editData(scope.row, 2)"
              v-if="scope.row.flowType=='00016'&&getListBtnState('approval', scope.row) == 'approval'"
            >
              通过
            </a>
            <a
              class="txt-color"
              @click="
                rejectDialogVisible = true;
                approveSuggest = '';
                form = scope.row;
              "
              v-if="getListBtnState('approval', scope.row) == 'approval'"
            >
              驳回
            </a>
            <a class="txt-color" @click="toRevoke(scope.row)" v-if="getListBtnState('revoke', scope.row) == 'revoke'">
              撤销
            </a>
            <a class="txt-color" @click="editData(scope.row, 1)" v-if="getListBtnState('edit', scope.row) == 'edit'">
              编辑
            </a>
            <a class="txt-color" v-if="getListBtnState('del', scope.row) == 'del'" @click="delData(scope.row)">
              删除
            </a>

            <a class="txt-color" v-if="getListBtnState('again', scope.row) == 'again'" @click="editData(scope.row, 3)">
              重新提交
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
      </span>
    </el-dialog>
    <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
      <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选择发起流程" :visible.sync="dialogFlow" width="900px" top="15%">
      <div class="flow-dialog">
        <div
          :class="currentFlowIndex == index ? 'flow-item flow-item-active' : 'flow-item'"
          @click="flowSelect(index)"
          v-for="(item, index) in flowList"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFlow = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitFlow()">确定</el-button>
      </span>
    </el-dialog>
    <!-- 运营报告 -->
    <el-dialog title="运营报告" :visible.sync="dialogVisibleOperation" width="760px" :close-on-click-modal="false" @close="closeOperationReport">
      <el-form label-width="200px" :label-position="right" class="demo-ruleForm">
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">是否转包任务：</span>
          <el-select
            class="fl"
            style="width: 400px"
            v-model="operationForm.isChangeService"
            placeholder="请选择"
            filterable
            @change="changeService"
          >
            <el-option v-for="item in getCodeListByKey('是否')"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="operationForm.isChangeService=='N'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">是否平台专属任务：</span>
          <el-select
            class="fl"
            style="width: 400px"
            v-model="operationForm.isPlatformTask"
            placeholder="请选择"
            filterable
            @change="changePlatTask"
          >
            <el-option v-for="item in getCodeListByKey('是否')"
              :key="item.value"
              :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="operationForm.isPlatformTask=='N'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">企业名称：</span>
          <el-select
            filterable
            v-model="operationForm.tenantGuid"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
            @change="changeTenant"
          >
            <el-option
              v-for="item in tenantList"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="operationForm.isPlatformTask=='Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">企业名称：</span>
          <el-select
            filterable
            v-model="operationForm.tenantGuid"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
            @change="changePlatTenant"
          >
            <el-option
              v-for="item in platTenantList"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div style="clear: both"></div>
        <el-form-item v-show="operationForm.isChangeService=='Y'?false:operationForm.isPlatformTask=='N'?true:false">
          <span slot="label" style="color: red">*</span>
          <span slot="label">组织名称：</span>
          <el-select
            filterable
            v-model="operationForm.organisationGuid"
            @change="changeOrganisation"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in organisationList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">关联质量考核流程
            <el-popover placement="top-start" content="该月份对应的质量审核通过的考核总金额" trigger="hover">
              <i slot="reference" class="el-icon-question"></i>
            </el-popover>：
          </span>
          <el-select
            filterable
            multiple
            v-model="operationForm.qualityCheckGuidList"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in qualityList"
              :key="item.guid"
              :label="item.accountMonth + '-' + formatMoney(item.totalMoney)+'元'"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item v-show="operationForm.isPlatformTask=='N'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">核算月：</span>
          <el-date-picker
            v-model="operationForm.accountMonth"
            class="fl"
            style="width: 400px"
            value-format="yyyy-MM"
            type="month"
            placeholder="请选择核算月"
            @change="changeAccountMonth"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="showServiceProvider && operationForm.isChangeService == 'Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">总服务商：</span>
          <el-select
            :key="`serviceTenantGuidList-${operationForm.isChangeService}`"
            @change="changeGeneralServiceTenant"
            multiple
            filterable
            collapse-tags
            v-model="operationForm.serviceTenantGuidList"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in serviceTenantList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 总服务商 | 三方 Sass 服务商  才展示 -->
        <el-form-item v-show="showServiceProvider && operationForm.isChangeService == 'Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">接包服务商</span>
          <el-select
            @change="chanegNewServiceTenant"
            multiple
            filterable
            collapse-tags
            v-model="operationForm.newServiceTenantGuids"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in newServiceTenantList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 总服务商 | 三方 Sass 服务商  才展示 -->
        <!-- <el-form-item v-show="showServiceProvider && operationForm.isChangeService == 'Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">接包服务商运营报告流程：</span>
          <el-select
            multiple
            collapse-tags
            filterable
            v-model="operationForm.newServiceOperationReportGuids"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
            @change="newServiceOperationReportChange"
          >
            <el-option
              v-for="item in newServiceTenantReportList"
              :key="item.guid"
              :label="item.name"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item v-show="operationForm.isPlatformTask == 'N'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务包选择：</span>
          <el-select
            class="fl"
            style="width: 400px"
            v-model="operationForm.isSelectTask"
            placeholder="请选择"
            filterable
            @change="changePrecise"
          >
            <el-option v-for="item in isOption" :key="item.value" :label="item.text" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="showAcceptPackageOrganizationName">
          <span slot="label" style="color: red">*</span>
          <span slot="label">接包组织名称：</span>
          <el-select 
           v-model="operationForm.organisationGuid"
          @change="changeDataOrganisation"
           placeholder="请选择"
           class="fl"
           style="width: 400px"
           filterable
          >
            <el-option
              v-for="item in organisationDataList"
              :key="item.guid"
              :label="item.organisationName"
              :value="item.guid"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="operationForm.isSelectTask == 'N' && operationForm.isPlatformTask=='N'">
          <span slot="label" style="color: red"> </span>
          <span slot="label">账单周期：</span>
          <el-select 
           v-model="operationForm.billCycleList" 
           placeholder="请选择" 
           class="fl"
           multiple
           style="width: 400px" 
           filterable>
            <el-option v-for="item in billCycleListArr" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          
        </el-form-item>
        <el-form-item v-show="operationForm.isSelectTask == 'Y' && operationForm.isPlatformTask=='N'">
          
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务包标题：</span>
          <el-select
            v-model="operationForm.taskGuidList"
            placeholder="请选择"
            class="fl"
            style="width: 400px" 
            filterable
            multiple
          >
            <el-option v-for="item in taskList" :key="item.guid" :label="item.taskTitle" :value="item.guid">
            </el-option>
          </el-select>
          
          
        </el-form-item>
        <el-form-item v-show="operationForm.isPlatformTask=='Y'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务包标题：</span>
          <el-select
            v-model="operationForm.taskGuidList"
            placeholder="请选择"
            class="fl"
            style="width: 400px" 
            filterable
            multiple
          >
            <el-option v-for="item in platTaskList" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
          
          
        </el-form-item>
        <el-form-item v-show="operationForm.isSelectTask == 'Y' && operationForm.isPlatformTask=='N'">
          <span slot="label" style="color: red"> </span>
          <span slot="label">账单周期：</span>
          <el-select 
            v-model="operationForm.billCycleList" 
            placeholder="请选择" 
            class="fl"
            style="width: 400px" 
            filterable 
            multiple 
            collapse-tags>
            <el-option v-for="item in billCycleOption" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
          
          
        </el-form-item>
        <el-form-item v-show="operationForm.isPlatformTask=='N'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">选择合同：</span>
          <el-select 
           v-model="operationForm.contractGuid" 
           placeholder="请选择" 
           class="fl"
           style="width: 400px" 
           filterable>
            <el-option v-for="item in contractList" :key="item.guid" :label="item.text" :value="item.guid">
            </el-option>
          </el-select>
          
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">合格状态：</span>
          <el-select
            filterable
            multiple
            v-model="operationForm.qualityStateList"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in getCodeListByKey('合格状态')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="operationForm.isPlatformTask=='N'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">是否含税：</span>
          <el-select
            filterable
            v-model="operationForm.isContainServiceFee"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in trueOrFalseOption"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">得分显示规则：</span>
          <el-select
            filterable
            v-model="operationForm.scoreRule"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in getCodeListByKey('得分显示规则')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
        <!-- <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">应付金额：</span>
          <el-input
            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
            maxlength="12"
            @blur="operationForm.invoiceAmount = $event.target.value"
            v-model.trim="operationForm.invoiceAmount"
            class="contract-base-content"
            placeholder="请输入"
            clearable
          ></el-input>
        </el-form-item> -->
        <el-form-item>
          <span slot="label" style="color: red"> </span>
          <span slot="label">备注说明：</span>
          <el-input
            class="fl"
            style="width: 400px"
            type="textarea"
            :rows="5"
            :maxlength="200"
            placeholder="最多可输入200个字"
            v-model="operationForm.remarks"
          >
          </el-input>
        </el-form-item>
        <el-form-item v-if="taskPriceModel == 2">
          <span slot="label" style="color: red">*</span>
          <span slot="label">调研报告类型：</span>
          <el-select
            filterable
            v-model="operationForm.researchReportType"
            placeholder="请选择"
            class="fl"
            style="width: 400px"
          >
            <el-option
              v-for="item in getCodeListByKey('调研报告类型')"
              :key="item.value"
              :label="item.text"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">运营报告：</span>
          <el-upload
            class="upload-demo fl t-left report-file-upload"
            action="#"
            multiple
            accept=".pdf,.PDF,.docx,.xlsx,.doc,.xlsm"
            :on-remove="handleRemove"
            :http-request="uploadFile"
            :file-list="reportFile"
            :beforeUpload="beforeAvatarUpload"
          >
            <el-button size="medium" type="info">点击上传文件</el-button>
            <div class="file-operate" slot="file" slot-scope="{ file }">
              <div class="file-name nowrap-ellipsis" :title="file.name">{{ file.name }}</div>
              <div class="file-preview" @click="handleRemove(file)">删除</div>
            </div>
            <div slot="tip" class="el-upload__tip line-h30">
              当前支持 word、pdf、excel，请使用 Office 2010 及以上版本，否则可能出现乱码，单个文件不得大于100M
            </div>
            <div v-if="reportUploading" class="report-upload-progress">
              <p class="report-upload-progress-text">{{ reportUploadProgressText }}</p>
              <el-progress color="#4fa1a4"  :stroke-width="12" :percentage="reportUploadProgress"></el-progress>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item v-if="operationForm.isChangeService=='Y'">
          <span slot="label">关联下游付款：</span>
          <el-input
            class="fl"
            style="width: 400px"
            v-model="operationForm.settleGuidListStr"
            placeholder="请选择关联下游付款"
            readonly
            @focus="onFocusRelevance"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="closeOperationReport">取 消</el-button>
        <el-button size="medium" type="info" @click="addQuality" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 付款 -->
    <el-dialog title="付款通知单审批" :visible.sync="dialogVisiblePay" width="1100px">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="9"
            ><div class="search-area-div">关键字搜索：</div>
            <el-input
              v-model.trim="operationPage.searchKey"
              class="ipt-sty"
              placeholder="请输入"
              clearable
              maxlength="100"
            ></el-input>
          </el-col>
          <el-col :span="9">
            <div class="search-area-div">关联状态：</div>
            <el-select clearable v-model="operationPage.isUsed" class="ipt-sty" placeholder="请选择">
              <el-option
                v-for="item in isUsedOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" type="info" @click="getOperationList(1)">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptyOperationSearch">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="back-color-fff content-main-box"  style="height: 100%">
        <el-table :data="operationTableData" stripe border style="width: 100%" v-loading="tableLoading" height="60vh" ref="payMultipleTable" @selection-change="handleSelectionChangePay" :row-key="(row) => row.guid" >
          <el-table-column type="selection" :reserve-selection="true" width="50" header-align="center" align="center"></el-table-column>
          <el-table-column label="序号" width="50" header-align="center" align="center" >
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="90"
          >
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="160"
          >
            <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizOrganisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.taskTitleName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonthName"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="70"
          >
            <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="currentPayAmount"
            label="应付/开票金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisiblePay = false">取 消</el-button>
        <el-button size="medium" type="info" @click="payTableSubmit" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 开票 -->
    <el-dialog title="开票申请审批" :visible.sync="dialogVisibleInvoicing" width="1100px">
      <!-- 查询条件 -->
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="9"
            ><div class="search-area-div">关键字搜索：</div>
            <el-input
              v-model.trim="payPage.searchKey"
              class="ipt-sty"
              placeholder="请输入"
              clearable
              maxlength="100"
            ></el-input>
          </el-col>
          <el-col :span="9">
            <div class="search-area-div">关联状态：</div>
            <el-select clearable v-model="payPage.isUsed" class="ipt-sty" placeholder="请选择">
              <el-option
                v-for="item in isUsedOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <el-button size="mini" type="info" @click="getPayList(1)">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptyPaySearch">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="back-color-fff content-main-box" style="height: 100%">
        <el-table :data="InvoicingTableData" stripe border style="width: 100%" v-loading="tableLoading" height="60vh" ref="invoicingMultipleTable" @selection-change="handleSelectionChangeInvoicing" :row-key="(row) => row.guid" >
          <el-table-column type="selection" :reserve-selection="true" width="50" header-align="center" align="center"></el-table-column>
          <el-table-column label="序号" width="50" header-align="center" align="center" >
            <template slot-scope="scope">
              {{ scope.$index + 1 }}
              <!-- {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }} -->
            </template>
          </el-table-column>
          <el-table-column
            prop="flowName"
            label="流程名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.flowName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="90"
          >
            <template slot-scope="scope">{{ scope.row.staffName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizTenantName"
            label="药企名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="160"
          >
            <template slot-scope="scope">{{ scope.row.bizTenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="bizOrganisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.bizOrganisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="taskTitleName"
            label="任务包名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="140"
          >
            <template slot-scope="scope">{{ scope.row.taskTitleName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonthName"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="90"
          >
            <template slot-scope="scope">{{ scope.row.accountMonthName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="currentPayAmount"
            label="应付/开票金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.currentPayAmount | numFmt | numDigit }}</template>
          </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisibleInvoicing = false">取 消</el-button>
        <el-button size="medium" type="info" @click="InvoicingTableSubmit" v-loading.fullscreen.lock="fullscreenLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <!-- 打印 -->
    <PassDialog :flowType="form.flowType" @passSuccess="getList(1)" ref="pass" ></PassDialog>
    <!-- 关联下游付款 弹窗 -->
    <SettlePayDialog  @submit="submitSettlePay" @close="closeSettlePay" ref="settlePayRef"></SettlePayDialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import workFlowCommon from '@/uilt/workFlowCommon';
import Decimal from "decimal.js"
import PassDialog from './components/passDialog.vue';
import SettlePayDialog from './components/SettlePayDialog.vue';
import { ServiceProviderTypeEnum } from '../mixins/getTenantDetail'
import getTenantDetail from '../mixins/getTenantDetail';
export default {
  components:{
    PassDialog,
    SettlePayDialog,
  },
  mixins:[getTenantDetail],
  data() {
    return {
      ServiceProviderTypeEnum,
      //价格模式
      taskPriceModel:null,
      newServiceTenantReportList:[],////接包服务商运营报告
      newServiceTenantList:[],//接包服务商
      serviceTenantList: [],//总服务商
      allServiceTenantList: [],//所有服务商
      //服务商类型 3总包服务商 、 2三方接包服务商  1三方sass服务商
      serviceProviderType:'',
      categoryList: [
        { text: '是', value: 2 },
        { text: '否', value: 1 },
      ],
      value: null,
      tableHeight: window.innerHeight - 310,
      contentMainHeight: window.innerHeight - 240,
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      flowType: '00014',
      fullscreenLoading: false,
      currentStaffGuid: null,
      tenantList: [], //公司名称
      platTenantList: [], //平台专属公司名称
      tableOrganisationList:[],
      organisationList: [],
      organisationDataList: [],
      qualityList: [],
      dialogVisibleSettlePay: false, //关联下游付款 弹窗
      dialogVisibleOperation: false, //运营报告
      dialogVisiblePay: false, //付款
      dialogVisibleInvoicing: false, //开票
      rowData:{},
      page: {
        flowStaffGuids:null,
        listType:0,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: null,
        organisationGuids: [],
        accountMonth: null,
        approveState: '',
        flowNo:'',//流程编号
        flowType: '', //流程类型
        // currentTenantGuid: '',
        // searchKey: '',
        startTime: '',
        endTime: '',
        // isUsed: null, //关联状态
        isHedgeList:['Y','N'],//是否对冲
        serviceTenantGuid:null,//服务商名称
      },
      operationPage: {
        pageIndex: 1,
        pageSize: -1,
        searchCode:'A001',
        approveState: 'Y',
        flowType: '00016',
        isUsed: 'N',
        searchKey: null,
        flowStaffGuids: [],
      },
      payPage: {
        pageIndex: 1,
        pageSize: -1,
        searchCode:'A001',
        approveState: 'Y',
        searchCode: "A001",
        flowType: '00017',
        isUsed: 'N',
        searchKey: null,
        flowStaffGuids: [],
      },
      timeListS: [],
      //运营报告
      operationForm: {
        guid: null,
        tenantGuid: null,
        tenantName: null,
        organisationGuid: null,
        organisationName: null,
        remarks: null,
        researchReportType:null,
        isPlatformTask:'N',
        bizApproveState: null,
        // qualityCheckGuidList: [],
        accountMonth:null,//核算月
        isSelectTask: 'Y', //是否选择任务包
        taskGuidList: [], //任务包GUID列表
        billCycleList: [], //账单周期
        contractGuid:'',// 选择合同
        reportFile: [],
        currentTenantGuid: null,
        isContainServiceFee:null,//是否含税
        scoreRule: '',//得分显示规则
        qualityStateList:[],//合格状态
        newServiceOperationReportGuids:[],
        newServiceTenantGuids:[],
        serviceTenantGuidList:[],
        isChangeService:'N',
        settleGuidList: [],// 关联下游付款GUID列表
        settleGuidListStr:'', // 关联下游付款列表 展示使用
  
      },
      billCycleListSelect:[],//账单周期多选
      reportFile: [],
      reportUploadTasks: {},
      flowList: ['运营报告流程', '付款通知单流程', '开票申请流程', '预开票流程'],
      currentFlowIndex: 0,
      tableLoading: false,
      tableData: [],
      payTableData: [],
      InvoicingTableData: [],
      right: 'right',
      approveSuggest: '',
      passDialogVisible: false,
      rejectDialogVisible: false,
      form: '',
      approveStateOption: [
        { label: '全部', value: '' },
        { label: '草稿中', value: 'N' },
        { label: '审批中', value: 'A' },
        { label: '已通过', value: 'Y' },
        { label: '已驳回', value: 'R' },
        { label: '已撤销', value: 'C' },
      ],
      flowTypeOption: [
        { label: '全部', value: '' },
        { label: '运营报告流程', value: '00016' },
        { label: '付款通知单流程', value: '00017' },
        { label: '开票申请流程', value: '00018' },
        { label: '预开票流程', value: '00019' },
      ],
      isUsedOption: [
        { label: '全部', value: '' },
        { label: '已关联', value: 'Y' },
        { label: '未关联', value: 'N' },
      ],
      qualifiedStatusOption: [
        { label: '合格', value: '' },
        { label: '部分合格', value: 'Y' },
        { label: '不合格', value: 'N' },
      ],
      trueOrFalseOption: [
        { text: '是', value: 'Y' },
        { text: '否', value: 'N' },
      ],
      trueOrFalseOptionII:[
        { text: '已对冲', value: 'Y' },
        {text: '未对冲', value: 'N' },
      ],
      isOption: [
        { text: '是', value: 'Y' },
        { text: '否', value: 'N' },
      ],
      taskList:[],
      platTaskList:[],
      contractList:[],
      billCycleListArr: [],
      billCycleOption: ['一期', '二期', '三期', '四期', '五期', '六期', '七期', '八期', '九期', '十期', '十一期', '十二期', '十三期', '十四期', '十五期', '十六期', '十七期', '十八期', '十九期', '二十期', '二十一期', '二十二期', '二十三期', '二十四期', '二十五期', '二十六期', '二十七期', '二十八期', '二十九期', '三十期'],
      dialogVisible: false, //运营报告弹框
      dialogFlow: false,
      //开票所选数据
      invoicingSelectData:[],
      //付款所选
      paySelectData:[],
      operationTableData:[],
      url: `/${serverConfig.msCommonAdminCloudService}/obs/upload-file`,
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      token: {
        'Content-Type': 'multipart/form-data',
        Authorization: store.state.token,
      },
      staffList:[],
      isLastNode: false,
    };
  },
  filters: {
    billFilter(list) {
      let str='-'
      if(list&&list.length>0){
        str=list.join('、')
      }
      return str
    }
  },

  async created() {
    let userinfo = JSON.parse(localStorage.userInfo);
    this.currentStaffGuid = userinfo.staffGuid;
    await this.Mixins_getServiceProviderType();
    this.getOrganisationDataList();
    this.getList();
    this.getTenantList();
    this.getPlatTenantList()
    this.getStaffList();
    this.getServiceProviderType();
    this.getNewServiceTenantList();
    this.getGeneralServiceTenantList();
    this.getAllServiceTenantList();
  },
  activated(){
    this.operationForm = {
      guid: null,
      tenantGuid: null,
      tenantName: null,
      organisationGuid: null,
      organisationName: null,
      remarks: null,
      researchReportType:null,
      isPlatformTask:'N',
      bizApproveState: null,
      // qualityCheckGuidList: [],
      accountMonth:'',//核算月
      isSelectTask: null, //是否选择任务包
      taskGuidList: [], //任务包GUID列表
      billCycleList: [], //账单周期
      contractGuid:'',// 选择合同
      reportFile: [],
      currentTenantGuid: null,
      isContainServiceFee:null,//是否含税
      scoreRule: '',//得分显示规则
      qualityStateList:[],//合格状态
      newServiceOperationReportGuids:[],
      newServiceTenantGuids:[],
      serviceTenantGuidList: [],
      isChangeService:'N',
    },
    this.reportFile=[]
    this.resetReportUploadProgress()
    this.getList();
    this.getServiceProviderType();
    this.getNewServiceTenantList();
    this.getGeneralServiceTenantList();
    this.getAllServiceTenantList();
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
          this.tableHeight = window.innerHeight - 400;
          this.contentMainHeight = window.innerHeight - 320;
          return;
      }
      if (!val) {
          this.tableHeight = window.innerHeight - 310;
          this.contentMainHeight = window.innerHeight - 240;
          return;
      }
    },
    
  },
  computed: {
    /**是否展示 接包组织名称 */
    showAcceptPackageOrganizationName() {
      // 是否转包任务选择 '是' && 任务包选择 '否' && 是 三方接包服务商
      return (
        this.operationForm.isChangeService == "Y" &&
        this.operationForm.isSelectTask == "N" &&
        this.isThirdPartyContractor
      );
    },
    /**是否是 三方接包服务商*/
    isThirdPartyContractor() {
      try {
        // 可以直接访问到 mixins 中的 data 变量
        const { serviceProviderType } = this.Mixins_tenantDetail.servicerCredential;
        return serviceProviderType === ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR;
      } catch (error) {
        console.log(error);
      }
    },
    /**是否是 总包服务商*/
    isGeneralContractor() {
      return this.serviceProviderType === ServiceProviderTypeEnum.GENERAL_CONTRACTOR;
    },
    showServiceProvider() {
      const serviceProviderTypeList = [
        ServiceProviderTypeEnum.THIRD_PARTY_SASS,
        ServiceProviderTypeEnum.GENERAL_CONTRACTOR
      ];
      // 三方 Sass 服务商 | 总包服务商
      return serviceProviderTypeList.includes(this.serviceProviderType);
    },
    // 是否正在上传
    reportUploading() {
      return Object.keys(this.reportUploadTasks).length > 0;
    },
    // 上传进度
    reportUploadProgress() {
      const tasks = Object.values(this.reportUploadTasks);
      if (!tasks.length) {
        return 0;
      }
      const loaded = tasks.reduce((sum, task) => sum + (task.loaded || 0), 0);
      const total = tasks.reduce((sum, task) => sum + (task.total || 0), 0);
      if (!total) {
        return 0;
      }
      return Math.min(100, Math.floor((loaded / total) * 100));
    },
    // 上传进度文本
    reportUploadProgressText() {
      const tasks = Object.values(this.reportUploadTasks);
      if (!tasks.length) {
        return '';
      }
      const progress = this.reportUploadProgress;
      if (tasks.length === 1) {
        return `正在上传：${tasks[0].name}（${progress}%）`;
      }
      return `正在上传 ${tasks.length} 个文件（${progress}%）`;
    },
  },
  methods: {
    // 根据 scoreRule 格式化打分
    getComprehensiveGrade(row) {
      if (!row.comprehensiveGrade) return '-';
      // scoreRule == 1 保留两位小数 向上取整
      if (row.scoreRule == 1) {
        return this.ceilToTwoDecimals(row.comprehensiveGrade);
      }
      // scoreRule == 2  四舍五入
      if (row.scoreRule == 2) {
        return Number(row.comprehensiveGrade).toFixed(2);
      }
    },
    // 保留两位小数 向上进一
    ceilToTwoDecimals(num) {
      // 产品想要的效果是保留两位小数 必须向上进一
      // 比如 6.000000 向上取整应该是 是 6.00, 但是产品需要 6.01
      // 6.000001 向上取整 6.01
      // 6.000009 向上取整是 6.01
      // 6.010000 向上取整是 6.01 产品需要 6.02
      // 如果floorToTwoDecimals大于等于100，不需要加0.01
      
      // 取整后加 0.01
      const value = new Decimal(num);
      const floorToTwoDecimals = value.times(100).floor().dividedBy(100);
      if (floorToTwoDecimals.greaterThanOrEqualTo(100)) {
        return floorToTwoDecimals.toFixed(2);
      }
      return floorToTwoDecimals.plus(0.01).toFixed(2);
    },
    // 获取是否是最后一个节点
    async getLastNode() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: this.form.camundaDeploymentId,
        processInstanceId: this.form.camundaInstanceId
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-last-node`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      this.isLastNode = data.data || false;
    },
    //获取接包服务商
    getNewServiceTenantList() {
      const params = {
        serviceTenantGuidList:  [...this.operationForm.serviceTenantGuidList],
      }
      if (!params.serviceTenantGuidList?.length) {
        params.serviceTenantGuidList = [localStorage.guid];
      }
      this.api.postJson(`${serverConfig.msSalesPerformService}/task/data/get-new-tenant-map`, params.serviceTenantGuidList).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.newServiceTenantList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //获取总服务商
    async getGeneralServiceTenantList() {
      const query = {
        serviceProviderTypeList: [
          ServiceProviderTypeEnum.THIRD_PARTY_SASS,
          ServiceProviderTypeEnum.GENERAL_CONTRACTOR,
        ],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant-expand/service/get-list`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.serviceTenantList = data.data || [];
    },
    //获取所有服务商
    async getAllServiceTenantList() {
      const query = {
        serviceProviderTypeList: [
          ServiceProviderTypeEnum.THIRD_PARTY_SASS,
          ServiceProviderTypeEnum.THIRD_PARTY_CONTRACTOR,
          ServiceProviderTypeEnum.GENERAL_CONTRACTOR,
        ],
      };
      const { data } = await this.api.postJson(
        `/${serverConfig.msCustomerService}/tenant-expand/service/get-list`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return;
      }
      this.allServiceTenantList = data.data || [];
    },
    defaultGeneralServiceTenant() {
      if (!this.operationForm.serviceTenantGuidList?.length) {
        const currentTenant = this.serviceTenantList.find(item => item.guid === localStorage.guid);
        this.operationForm.serviceTenantGuidList = currentTenant ? [localStorage.guid] : [];
      }
    },
    changeGeneralServiceTenant() {
      this.operationForm.taskGuidList = [];
      this.taskList = [];
      this.operationForm.settleGuidList = [];
      this.operationForm.settleGuidListStr = '';
      this.getTaskList();
      this.getNewServiceTenantList();
    },
    chanegNewServiceTenant() {
      this.operationForm.newServiceOperationReportGuids = [];
      this.operationForm.taskGuidList = [];
      this.newServiceTenantReportList = [];
      this.operationForm.settleGuidList = [];
      this.operationForm.settleGuidListStr = '';
      this.taskList = [];
      this.getTaskList();
      this.getNewServiceTenantReport();
    },

    //获取接包服务商运营报告流程
    getNewServiceTenantReport() {
      if(!this.operationForm.newServiceTenantGuids||!this.operationForm.newServiceTenantGuids.length||!this.operationForm.accountMonth) return;
      let req = {
        tenantGuid: localStorage.guid,
        pageSize: -1,
        pageIndex: 1,
        accountMonth: this.operationForm.accountMonth.replace('-', ''),
        approveState: 'Y',
        isUsedOperationReport:'N',
        approveState: 'Y',
        flowType: '00016',
        serviceTenantGuids:this.operationForm.newServiceTenantGuids
      }
      this.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        let list = res.data.data.records || [];
        list.forEach(currentRow=>{
          currentRow.name = currentRow['staffName'] + ' _ ' + currentRow['bizTenantName'] + ' _ ' + currentRow['accountMonthName'] + (currentRow['currentPayAmount'] ? (' _ ' + this.formatMoney(currentRow['currentPayAmount']) + '(元)') : '');
        })
          this.newServiceTenantReportList = list;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    newServiceOperationReportChange(){
      this.operationForm.taskGuidList = [];
      this.getTaskList(true);
    },
    getServiceProviderType() {
      let url = `/${serverConfig.msCustomerService}/tenant-expand/servicer-credential/detail?tenantGuid=${localStorage.guid}`;
      this.api.get(url).then((resp) => {
        const { data } = resp;
        if (data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.serviceProviderType = data.data.serviceProviderType;
        }
      });
    },
    getStaffList() {
      let req = {
        "tenantGuid": localStorage.guid,
        "staffType": 1,
        "bizState": "Y"
      }
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff/get-select-staff`, req).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          console.log(res.data.data)
          this.staffList = res.data.data;
        } else {
          this.$message.error(res.data.data.msg);
        }
      });
    },
    //获取操作按钮显隐
    getListBtnState(btnType, row) {
      let approveVO = row;
      return workFlowCommon.getListBtnState(
        btnType,
        approveVO.approveState,
        approveVO.staffGuid,
        approveVO.approveStaffGuids,
        this.currentStaffGuid,
        row.bizApproveState,
      );
    },
    //获取审批状态
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    //获取药企
    getTenantList(val) {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
        relType:'123'
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取平台药企
    getPlatTenantList(val) {
      let self = this;
      self.api
        .get(`${serverConfig.msSalesPerformService}/platform-task/get-operation-report-tenant`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.platTenantList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    
    //选择流程
    flowSelect(index) {
      this.currentFlowIndex = index;
    },
    //点击跳转
    submitFlow() {
      if (this.currentFlowIndex === 0) {
        this.dialogVisibleOperation = true;
        this.dialogFlow = false;
        // this.$router.push('/upstreamOperationReportAdd');
      }
      if (this.currentFlowIndex === 1) {
        this.getOperationList(1)
        this.dialogVisiblePay = true;
        // this.$router.push('/upstreampaymentOrderAdd');
      }
      if (this.currentFlowIndex === 2) {
        this.getPayList(1);
        this.dialogVisibleInvoicing = true;
        // this.$router.push('/upstreamInvoicingAdd');
      }
      if (this.currentFlowIndex === 3) {
        this.dialogFlow = false;
        this.$router.push({
          path:'/upstreamAdvanceInvoiceAdd',
          query:{
            productGuid:this.$route.query.productGuid
          }
        });
      }
    },
    async passDialogClick(row){
      this.approveSuggest = '';
      this.form = row;
      if(row.flowType !== '00016'){
        if (row.isApplyInvoice == "Y") {
          const isSecondLastNode = await this.isSecondLastNode();
          if (isSecondLastNode) {
            this.editData(this.form, 2);
            return;
          }
        }
        this.isLastPerson();
      }else{
        this.passDialogVisible = true;
      }
    },
    // 是否是倒数第二节点（财务票据上传节点）
    async isSecondLastNode() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid: userinfo.staffGuid,
        deploymentId: this.form.camundaDeploymentId,
        processInstanceId: this.form.camundaInstanceId
      }
      const { data } = await this.api.postJson(
        `/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node-two`,
        query
      );
      if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
        this.$message.error(data.msg);
        return false;
      }
      return data.data || false;
    },
    //判断是否最后一个人审批
    isLastPerson(){
      let self = this;
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        staffGuid:userinfo.staffGuid,
        deploymentId:this.form.camundaDeploymentId,
        processInstanceId:this.form.camundaInstanceId
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`,query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if( res.data.data == true){
            this.editData(this.form,2);
          }else{
            this.passDialogVisible = true;
          }
          
          // self.$refs.pass.showPass = true;
          // self.$refs.pass.showForm = res.data.data || false;
          // self.$refs.pass.rowData = this.form ;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取筛选组织
    getTableOrganisationList(v) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.page.tenantGuid,
        sendTenantGuid: localStorage.guid,
      };
      if(!self.page.tenantGuid) return;
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableOrganisationList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取 接包组织名称 运营报告
    getOrganisationDataList() {
      const self = this;
      if (!self.isThirdPartyContractor) {
        // 不是三方接包服务商
        return;
      }
      const query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: this.Mixins_tenantDetail.servicerCredential.tenantGuid,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationDataList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    //获取组织 运营报告
    getOrganisationList(val) {
      let self = this;
      let query = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: val,
        sendTenantGuid: localStorage.guid,
      };
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.organisationList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    }, 
    getOrganisation(type) {
      if (!this.operationForm.tenantGuid && type !== 1) {
        this.$message.error('请选择药企名称后再选择部门!');
        return;
      }
      if (!this.page.tenantGuid && type == 1) {
        this.$message.error('请选择药企名称后再选择部门!');
        return;
      }
    },
    changePlatTask(val) {
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.sendTenantGuid === val) {
            this.operationForm.tenantName = i.sendTenantName;
          }
        });
        this.operationForm.tenantName=''
        this.operationForm.tenantGuid=''
        this.operationForm.organisationGuid= null,
        this.operationForm.organisationName= null,
        this.operationForm.remarks= null,
        this.operationForm.researchReportType= null,
        this.operationForm.bizApproveState= null,
        this.operationForm.accountMonth= null,
        this.operationForm.isSelectTask= this.operationForm.isChangeService == 'Y'?'Y':null,
        this.operationForm.taskGuidList= [],
        this.operationForm.billCycleList= [],
        this.operationForm.contractGuid= null,
        this.operationForm.reportFile= [],
        this.reportFile= [],
        
        this.operationForm.currentTenantGuid= null,
        this.operationForm.isContainServiceFee= null,
        this.operationForm.scoreRule = '';
        this.operationForm.qualityStateList= []
        this.operationForm.newServiceTenantGuids= [];
        this.operationForm.newServiceOperationReportGuids= [];
        this.operationForm.serviceTenantGuidList= [];
        
       
      }
    },
    changeService(value){
      this.operationForm.isPlatformTask = 'N';
      this.operationForm.isSelectTask = value == 'Y'?'Y':'N';
      this.operationForm.newServiceTenantGuids= [];
      this.operationForm.newServiceOperationReportGuids= [];
      this.operationForm.serviceTenantGuidList = [];
      this.operationForm.accountMonth= null;
      this.operationForm.taskGuidList= [];
      this.taskList = [];
      if (value == 'Y' && this.showServiceProvider) {
        this.defaultGeneralServiceTenant();
      }

    },
    changeTenant(val) {
      if (val) {
        this.tenantList.forEach((i) => {
          if (i.sendTenantGuid === val) {
            this.operationForm.tenantName = i.sendTenantName;
          }
        });
        this.operationForm.organisationGuid= null,
        this.operationForm.organisationName= null,
        this.operationForm.remarks= null,
        this.operationForm.researchReportType= null,
        this.operationForm.bizApproveState= null,
        this.operationForm.accountMonth= null,
        this.operationForm.isSelectTask = this.operationForm.isChangeService == 'Y'?'Y':null,
        this.operationForm.taskGuidList= [],
        this.operationForm.billCycleList= [],
        this.operationForm.contractGuid= null,
        this.operationForm.reportFile= [],
        this.reportFile= [],
        this.operationForm.settleGuidList = [];
        this.operationForm.settleGuidListStr = '';
        
        this.operationForm.currentTenantGuid= null,
        this.operationForm.isContainServiceFee= null,
        this.operationForm.scoreRule = '';
        this.operationForm.qualityStateList= [],
        
        this.getOrganisationList(val);//获取组织
        this.getContractList()//获取合同
        // this.getTaskList()//获取任务包
        // this.getCycleData()//获取账单周期
        // this.getQualityList();
        this.api.get('/ms-customer-service/tenant-expand/get-medicine-enterprise-detail?tenantGuid=' + val).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.taskPriceModel = res.data.data.taskPriceModel;
          }
        })
      }
    },
    changePlatTenant(val){
      if (val) {
        this.platTenantList.forEach((i) => {
          if (i.value === val) {
            this.operationForm.tenantName = i.text;
          }
        });
        this.operationForm.taskGuidList= [];
        this.operationForm.qualityStateList= [];
        this.operationForm.reportFile= [];
        this.reportFile= [];
        this.operationForm.remarks= null;
        this.operationForm.researchReportType= null;
        this.operationForm.currentTenantGuid= null;
  
      
        this.getPlatTaskList()//获取平台任务包
      }
    },
    changeDataOrganisation(val) {
      if (!val) {
        return;
      }
      const item = this.organisationDataList?.find((i) => i.guid === val);
      console.log(item)
      this.operationForm.organisationName = item?.organisationName;
    },
    changeOrganisation(val) {
      if (val) {
        this.organisationList.forEach((i) => {
          if (val === i.guid) {
            this.operationForm.organisationName = i.organisationName;
          }
        });
        this.operationForm.isSelectTask=null
        this.operationForm.taskGuidList=[]
        this.operationForm.billCycleList=[]
        
        // this.getTaskList()
        // this.getContractList()//获取合同
        // this.getCycleData()//获取账单周期
        // this.getCycleData()
        // this.getQualityList();
      }
    },
    //获取质量考核流程
    // getQualityList() {
    //   let self = this;
    //   if (!self.operationForm.tenantGuid || !self.operationForm.organisationGuid) {
    //     return;
    //   }
    //   self.api
    //     .postJson(
    //       `/${serverConfig.msSalesPerformService}/quality-assessment/get-pass-list?organisationGuid=${self.operationForm.organisationGuid}&tenantGuid=${self.operationForm.tenantGuid}&serviceTenantGuid=${localStorage.guid}`,
    //       [],
    //     )
    //     .then((res) => {
    //       if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //         self.qualityList = res.data.data || [];
    //       } else {
    //         self.$message.error(res.data.msg);
    //       }
    //     });
    // },
    //清空
    emptySearch() {
      this.page = {
        isHedgeList:['Y','N'],
        listType:'0',
        flowStaffGuids:null,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: null,
        organisationGuids: [],
        accountMonth: null,
        approveState: '',
        flowNo:'',
        flowType: '', //流程类型
        currentTenantGuid: '',
        searchKey: '',
        startTime: '',
        endTime: '',
        serviceTenantGuid:null,//服务商名称
      };
      this.timeListS = [];
      this.getList(1);
    },
    //type 为1编辑 3重新提交 2为详情
    editData(row, type) {
      let approveVO = row;
      let addPath = '';
      let detailPath = '';
      let query = {
        guid: row.guid,
        approveStaffGuid: approveVO.approveGuid,
        camundaInstanceId: approveVO.camundaInstanceId,
        camundaDeploymentId: approveVO.camundaDeploymentId,
        tenantGuid: row.tenantGuid,
        submitStaffGuid: approveVO.staffGuid,
        submitStaffName: approveVO.staffName,
        toType:type,
        productGuid:this.$route.query.productGuid
      };
      if (row.flowType == '00016') {
        //上游运营审批报告审核
        addPath = '/upstreamOperationReportAdd';
        detailPath = '/upstreamOperationReportDetail';
      }
      if (row.flowType == '00017') {
        //上游付款通知单审核
        addPath = '/upstreampaymentAdd';
        detailPath = '/upstreampaymentDetail';
      }
      if (row.flowType == '00018') {
        //上游付款单开票申请审核
        addPath = '/upstreamInvoicingAdd';
        detailPath = '/upstreamInvoicingDetail';
      }
      if (row.flowType == '00019') {
        //上游付款单预开票申请审核
        addPath = '/upstreamAdvanceInvoiceAdd';
        detailPath = '/upstreamAdvanceInvoiceDetail';
      }
      this.$router.push({
        path: type == 1 || type == 3 ? addPath : detailPath,
        query,
      });
    },
    getList(type) {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      if (type == 1) {
        self.page.pageIndex = 1;
      }
      if (self.page.isHedgeList.length == 0) {
        self.page.isHedgeList = ['Y', 'N'];
      }
      //日期处理 开始时间 结束时间
      if (
        self.timeListS &&
        Array.isArray(self.timeListS) &&
        self.timeListS.length > 0 &&
        self.timeListS[0] &&
        self.timeListS[1]
      ) {
        self.page.startTime = self.$moment(self.timeListS[0]).format('YYYY-MM-DD HH:mm:ss');
        self.page.endTime = self.$moment(self.timeListS[1]).format('YYYY-MM-DD 23:59:59');
      } else {
        self.page.startTime = '';
        self.page.endTime = '';
      }
      //核算月格式处理
      let query = JSON.parse(JSON.stringify(self.page));
      if(query.accountMonth){
        query.accountMonth = query.accountMonth.replace('-','');
      }
      delete query.totalPage
      delete query.totalRows
      self.tableLoading = true;
      query.staffGuid = userInfo.staffGuid;
      console.log('query',query);
      
      // query.currentServiceTenantGuid = localStorage.guid;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, query).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取付款单数据
    getPayList(type) {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      if (type == 1) {
        self.payPage.pageIndex = 1;
      }
      // self.payPage.currentServiceTenantGuid = localStorage.guid;
      self.payPage.flowStaffGuids = [userInfo.staffGuid];
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, self.payPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.InvoicingTableData = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 清空付款查询条件
    emptyPaySearch() {
      this.payPage.isUsed = null;
      this.payPage.searchKey = null;
      this.getPayList(1);
    },
    // 关闭运营报告
    closeOperationReport(){
      this.dialogVisibleOperation = false;
      this.dialogFlow = true;
      this.resetReportUploadProgress();
    },
    resetReportUploadProgress() {
      this.reportUploadTasks = {};
    },
    // 关联下游付款
    onFocusRelevance() {
      const data = {
        accountMonth: this.operationForm.accountMonth,
        operationReportTenantGuid: this.operationForm.tenantGuid,
        selectedRows: this.operationForm.settleGuidList,
        tenantGuidList: this.operationForm.serviceTenantGuidList || [],
        threeTenantGuidList: this.operationForm.newServiceTenantGuids || []
      }
      this.dialogVisibleOperation = false;
      this.$refs.settlePayRef.open(data);
    },
    // 关联下游付款 关闭弹窗
    closeSettlePay(){
      this.dialogFlow = false;
      this.dialogVisibleOperation = true;
    },
    // 关联下游付款 提交
    submitSettlePay(data){
      this.dialogVisibleOperation = true;
      let userInfo = JSON.parse(localStorage.userInfo);
      const list = data.map(item => {
        const accountMonth = item.accountMonth ? JSON.parse(item.accountMonth)?.[0] : '';
        return {
          guid: item.guid,
          // 流程发起人+上游药企公司简称+月份+费用总金额
          text: `${userInfo.staffName}_${item.operationReportTenantName}_${accountMonth}_${item.totalAmount}`
        }
      });
      this.operationForm.settleGuidList = list.map(item => item.guid);
      this.operationForm.settleGuidListStr = list.map(item => item.text).join(',');
    },
    //提交运营报告
    addQuality() {
      if (!this.operationForm.tenantGuid) {
        this.$message.error('企业名称不能为空!');
        return;
      }
      let orgShow =  this.operationForm.isChangeService=='Y'?false:this.operationForm.isPlatformTask=='N'?true:false
      if (!this.operationForm.organisationGuid && orgShow) {
        this.$message.error('组织名称不能为空!');
        return;
      }
      if (this.showAcceptPackageOrganizationName && !this.operationForm.organisationGuid) {
        this.$message.error('接包组织不能为空!');
        return;
      }
      // if (!this.operationForm.qualityCheckGuidList.length) {
      //   this.$message.error('是关联质量考核流程不能为空!');
      //   return;
      // }
      if (!this.operationForm.serviceTenantGuidList?.length && this.operationForm.isChangeService == 'Y' && this.showServiceProvider) {
        this.$message.error('总服务商不能为空!');
        return ;
      }
      if ((!this.operationForm.newServiceTenantGuids||!this.operationForm.newServiceTenantGuids.length) && this.operationForm.isChangeService=='Y'&&this.showServiceProvider) {
        this.$message.error('接包服务商不能为空!');
        return ;
      }
      // if ((!this.operationForm.newServiceOperationReportGuids||!this.operationForm.newServiceOperationReportGuids.length) && this.operationForm.isChangeService=='Y'&&this.showServiceProvider) {
      //   this.$message.error('接包服务商运营报告流程不能为空!');
      //   return ;
      // }
      if (!this.operationForm.isSelectTask && this.operationForm.isPlatformTask=='N') {
        this.$message.error('任务包选择不能为空!');
        return ;
      }
      
      // if (this.operationForm.isSelectTask == 'N' && !this.operationForm.billCycle) {
      //   this.$message.error('账单周期不能为空!');
      //   return ;
      // }
       if ((this.operationForm.isSelectTask == 'Y' || this.operationForm.isPlatformTask=='Y') && !this.operationForm.taskGuidList.length) {
        this.$message.error('任务包标题不能为空!');
        return ;
      }
      //  if (this.operationForm.isSelectTask == 'Y' && !this.billCycleListSelect.length) {
      //   this.$message.error('账单周期不能为空!');
      //   return ;
      // }
      if (!this.operationForm.contractGuid && this.operationForm.isPlatformTask=='N') {
        this.$message.error('合同不能为空!');
        return;
      }
      if (!this.operationForm.qualityStateList.length) {
        this.$message.error('合格状态不能为空!');
        return;
      }
      if (!this.operationForm.isContainServiceFee && this.operationForm.isPlatformTask=='N') {
        this.$message.error('是否含税不能为空!');
        return;
      }
      if(!this.operationForm.scoreRule) {
        this.$message.error('得分显示规则不能为空!');
        return;
      }
      if (!this.operationForm.researchReportType && this.taskPriceModel == '2') {
        this.$message.error('调研报告类型不能为空!');
        return;
      }
      if (!this.reportFile.length) {
        this.$message.error('运营报告不能为空!');
        return;
      }
      this.operationForm.reportFile=[]
      this.reportFile.forEach((i) => {
        let item = {
          fileName: i.name,
          path: i.path,
        };
        this.operationForm.reportFile.push(item);
      });
      //判断周期
      // if( this.operationForm.isSelectTask == 'Y' && this.billCycleListSelect.length > 0){
      //   this.operationForm.billCycle = this.billCycleListSelect.join(',');
      // }
      //核算月格式处理
      let query = JSON.parse(JSON.stringify(this.operationForm));
      delete query.settleGuidListStr;
      if(query.accountMonth){
        query.accountMonth = query.accountMonth.replace('-','');
      }
      
     
      // this.operationForm.billCycleList =  this.operationForm.billCycleList == '全部' ? [] :  this.operationForm.billCycleList;
      query.currentTenantGuid = localStorage.guid;
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/upstream/operation-report/save`, query)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.currentFlowIndex = 0;
            this.dialogVisibleOperation = false;
            this.$nextTick(() => {
              this.dialogFlow = false;
            })
            this.operationForm = {
              guid: null,
              tenantGuid: null,
              tenantName: null,
              organisationGuid: null,
              organisationName: null,
              remarks: null,
              researchReportType:null,
              isPlatformTask:'N',
              bizApproveState: null,
              // qualityCheckGuidList: [],
              accountMonth:'',//核算月
              isSelectTask: null, //是否选择任务包
              taskGuidList: [], //任务包GUID列表
              billCycleList: [], //账单周期
              contractGuid:'',// 选择合同
              reportFile: [],
              currentTenantGuid: null,
              isContainServiceFee:null,//是否含税
              scoreRule: '',//得分显示规则
              qualityStateList:[],//合格状态
              newServiceOperationReportGuids:[],
              newServiceTenantGuids:[],
              serviceTenantGuidList: [],
              isChangeService:'N',
              settleGuidList: [],
              settleGuidListStr: '',
            },
            this.reportFile = [];
            this.$router.push({
              path: '/upstreamOperationReportAdd',
              query: {
                guid: res.data.data,
                productGuid:this.$route.query.productGuid
              },
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //开票提交
    InvoicingTableSubmit() {
      if(!this.invoicingSelectData.length){
        this.$message.error('请先选择数据！')
        return
      }
      this.fullscreenLoading = true;
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}/upstream/payment-invoice-apply/init-data?currentTenantGuid=${localStorage.guid}`, this.invoicingSelectData)
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dialogFlow = false;
            this.currentFlowIndex = 0;
            this.invoicingSelectData = [];
            this.$refs.invoicingMultipleTable.clearSelection() //清除选中的数据
            this.dialogVisibleInvoicing = false;
            this.$router.push({
              path: '/upstreamInvoicingAdd',
              query: {
                guid: res.data.data,
                productGuid:this.$route.query.productGuid
              },
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取运营报告数据
    getOperationList(type) {
      let self = this;
      let userInfo = JSON.parse(localStorage.userInfo);
      if (type == 1) {
        self.operationPage.pageIndex = 1;
      }
      // self.operationPage.currentServiceTenantGuid = localStorage.guid;
      self.operationPage.flowStaffGuids = [userInfo.staffGuid];
      self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/list`, self.operationPage).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.operationTableData = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //清空运营报告条件查询
    emptyOperationSearch() {
      this.operationPage.isUsed = null;
      this.operationPage.searchKey = null;
      this.getOperationList(1);
    },
    //付款提交
    payTableSubmit(){
      if(!this.paySelectData.length){
        this.$message.error('请先选择数据！')
        return
      }
      this.fullscreenLoading = true;
      const params = {
        currentTenantGuid: localStorage.guid,
        operationReportGuids: this.paySelectData,
      }
     this.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/upstream/payment-ticket/init-data`,
          params
        )
        .then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.dialogFlow = false;
            this.currentFlowIndex = 0;
            this.paySelectData = [];
            this.$refs.payMultipleTable.clearSelection() //清除选中的数据
            this.dialogVisiblePay = false;
            this.$router.push({
              path: '/upstreampaymentAdd',
              query: {
                guid: res.data.data,
                productGuid:this.$route.query.productGuid
              },
            });
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //驳回提交
    toRejectSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      if (this.approveSuggest == '') {
        this.$message.error('请填写驳回理由！');
        return;
      }
      let query = {
        guid: this.form.approveGuid,
        flowType: this.form.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;

      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.rejectDialogVisible = false;
          this.$message.success('驳回成功！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //通过
    toPassSubmit() {
      let userinfo = JSON.parse(localStorage.userInfo);
      let query = {
        guid: this.form.approveGuid,
        flowType: this.form.flowType,
        approveSuggest: this.approveSuggest,
        approveStaffGuid: userinfo.staffGuid,
      };
      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.passDialogVisible = false;
          this.$message.success('审批通过！');
          this.getList();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //撤销
    async toRevoke(form) {
      let self = this;
      this.form = form;
      await this.getLastNode();
      this.$confirm('确定撤销吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          let query = {
            guid: form.approveGuid,
            flowType: form.flowType,
            approveStaffGuid: form.staffGuid,
          };
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('撤销成功！');
              // 付款通知单 最后一个节点 撤销  开票申请 为 是 跳转到 运营报告对冲
              if(form.flowType == '00017' && self.isLastNode && form.isApplyInvoice == "Y"){
                self.$router.push('/upstreamHedgingAdd')
                return
              }
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          self.$message({
            type: 'info',
            message: '已取消操作！',
          });
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    //开票单选择
    handleSelectionChangeInvoicing(val){
      this.invoicingSelectData = [];
      if(val && val.length > 0){
        val.forEach(i=>{
          this.invoicingSelectData.push(i.guid);
        })
      }
    },
    //付款选择
    handleSelectionChangePay(val){ 
      this.paySelectData = [];
      if(val && val.length > 0){
        val.forEach(i=>{
          this.paySelectData.push(i.guid);
        })
      }
      
    },
    handleExceed(files) {
      this.$message.warning(`当前限制选择 1 个文件`);
    },
    handleRemove(file) {
      let self = this;
      self.reportFile.forEach(function (j, ind) {
        if (j.path == file.path) {
          self.reportFile.splice(ind, 1);
        }
      });
    },
    //上传限制
    beforeAvatarUpload(file) {
      const maxSize = 100;
      const isLtMaxSizeM = file.size / 1024 / 1024 < maxSize;
      if (!isLtMaxSizeM) {
        this.$message({
          message: `上传文件大小不能超过 ${maxSize}MB!`,
          type: 'warning',
        });
      }
      return isLtMaxSizeM;
    },
    uploadFile(file) {
      let self = this;
      const uploadItem = file.file || file;
      const uid = file.uid || uploadItem.uid || `${Date.now()}_${uploadItem.name}`;
      const fileTotal = uploadItem.size || uploadItem.size || 0;
      let formData = new FormData();
      formData.append('image', uploadItem);
      self.$set(self.reportUploadTasks, uid, {
        name: uploadItem.name,
        loaded: 0,
        total: fileTotal,
      });
      return new Promise((resolve, reject) => {
        self.api
          .postImage(self.urlImg, formData, {
            onUploadProgress: (progressEvent) => {
              const total = progressEvent.total || fileTotal;
              const loaded = progressEvent.loaded || 0;
              const realPercent = total ? (loaded / total) * 100 : 0;
              self.$set(self.reportUploadTasks, uid, {
                name: uploadItem.name,
                loaded: realPercent >= 99 && total ? total * 0.99 : loaded,
                total,
              });
            },
          })
          .then((res) => {
            if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.error(res.data.msg || '上传失败,请重新上传!');
              reject(new Error(res.data.msg || '上传失败'));
              return
            }
            const task = self.reportUploadTasks[uid];
            if (task) {
              self.$set(self.reportUploadTasks, uid, {
                ...task,
                loaded: task.total,
              });
            }
            let item = {
              name: uploadItem.name,
              path: res.data.data,
            };
            self.reportFile.push(item);
            self.$message.success('上传成功');
            resolve(res);
          })
          .catch((err) => {
            self.$message.error('上传失败,请重新上传');
            reject(err);
          })
          .finally(() => {
            self.$delete(self.reportUploadTasks, uid);
          });
      });
    },
    // 删除
    delData(row) {
      var self = this;
      let url = '';
      if (row.flowType == '00016') {
        //上游运营审批报告审核
        url = '/upstream/operation-report/delete';
      }
      if (row.flowType == '00017') {
        //上游付款通知单审核
        url = '/upstream/payment-ticket/delete';
      }
      if (row.flowType == '00018') {
        //上游付款单开票申请审核
        url = '/upstream/payment-invoice-apply/delete';
      }
      if (row.flowType == '00019') {
        //上游付款单预开票申请审核
        url = '/upstream/payment-plan-invoice-apply/delete';
      }
      self
        .$confirm('删除后不可恢复，确定删除吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
        .then(() => {
          self.fullscreenLoading = true;
          self.api.postJson(`/${serverConfig.msSalesPerformService}${url}`, [row.guid]).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.fullscreenLoading = false;
              self.$message.success('删除成功');
              self.page.pageIndex = 1;
              self.getList();
            } else {
              self.$message.error(res.data.msg);
            }
          });
        });
    },
    formatMoney(num) {
      // 将数字转换为字符串并保留两位小数
      num = num.toFixed(2);

      // 将字符串按小数点分割成整数部分和小数部分
      var parts = num.toString().split(".");

      // 将整数部分每三位加一个逗号
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      // 将整数部分和小数部分拼接起来
      return parts.join(".");
    },
    renderHeader: function (h, { column, $index }) {
      return [
        column.label,
        h(
          'el-tooltip',
          {
            props: {
              placement: 'top',
              effect: 'dark',
              //content:"提示框内容",//如果提示内容短不需要换行，直接使用这个提示内容
            },
          },
          [
            h(
              'div',
              {
                //当前div是为了实现换行，就这换行研究了好久。。。
                slot: 'content',
              },
              [
                '应付金额=任务金额*药企分值/100+服务费',
              ],
            ),
            h('span', {
              //问号模块
              class: {
                'el-icon-question': true,
              },
            }),
          ],
        ),
      ];
    },
    // 取消关联流程，新增任务包选择
    // 获取合同列表
    getContractList(){
        let that=this
        console.log('合同',that.operationForm.tenantGuid);
        
        if(!that.operationForm.tenantGuid) return
        let tenantGuid=that.operationForm.tenantGuid
        that.api
        .get(`/${serverConfig.msCustomerService}/contract/get-child-tenant-all-contract?serviceTenantGuid=${localStorage.guid}&tenantGuid=${tenantGuid}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            // row.scoreList = res.data.data.details;
            that.contractList=res.data.data||[]
            let name=''
            let date=''
            let rate=''
            let contractCode = ''
            let isInsideDeduction = ''
            that.contractList.forEach((item,index)=>{
              name = item.contractName
              isInsideDeduction = item.isInsideDeduction == 'Y' ? '(内扣)_' : ''
              date=item.signDate?(item.signDate+ '_'):''
              rate=item.chargeRate?( item.chargeRate ):''
              contractCode = item.contractCode ? ('_' + `【${item.contractCode}】` ) : ''
              
              that.contractList[index].text= name + isInsideDeduction  + date +  + rate + '%' + contractCode
            })
            if(that.contractList.length==1){
              this.operationForm.contractGuid=that.contractList[0].guid
            }
            
            
          } else {
            that.$message.error(res.data.msg);
          }
        });
    },
    // 任务包选择
    changePrecise(val) {
      console.log('vv',val);
      this.operationForm.taskGuidList=[]
      this.operationForm.billCycleList=[]
      if (this.showAcceptPackageOrganizationName) {
        this.operationForm.organisationGuid = null;
        this.operationForm.organisationName = null;
      }
      if(val==='Y'){
        this.taskList = [];
        this.getTaskList()
      }else{
        if (this.showServiceProvider && this.operationForm.isChangeService == 'Y') {
          // // 三方 Sass 服务商 | 总包服务商  && 是转包任务 用 newServiceTenantReportList 里面的周期
          // const selectReportGuids = this.newServiceTenantReportList?.filter(item => {
          //   return this.operationForm.newServiceOperationReportGuids?.includes(item.guid)
          // })
          // const billCycleList = selectReportGuids?.map(item => item.billCycleList)?.flat() || [];
          // this.billCycleListArr = [...new Set(billCycleList)];
          this.billCycleListArr = this.billCycleOption;
          return;
        }
        this.billCycleListArr=[]
        this.getCycleData()//获取账单周期
      }
      
      // this.billCycleListSelect = [];
      // this.changeAccountMonth();
      
    },
    changeAccountMonth() {
      this.taskList = [];
      this.operationForm.isSelectTask = this.operationForm.isChangeService == 'Y'?'Y':null;
      this.operationForm.taskGuidList = [];
      this.operationForm.billCycleList = [];
      this.operationForm.newServiceOperationReportGuids = [];
      this.getTaskList();
      this.chanegNewServiceTenant();
      // this.getCycleData();
    },
    //获取周期
    getCycleData() {
      let self = this;
      if (!this.operationForm.tenantGuid) {
        // this.$message.error('请选择药企名称!');
        return;
      }
      if (!this.operationForm.accountMonth) {
        // this.$message.error('请选择核算月!');
        return;
      }
      let accountMonth = JSON.parse(JSON.stringify(this.operationForm.accountMonth));
      accountMonth = accountMonth.replace('-', '');

      let tenantGuid = this.operationForm.tenantGuid;
      if (this.isThirdPartyContractor) {
        tenantGuid = localStorage.guid;
      }
      self.api
        .postJson(
          `/${serverConfig.msSalesPerformService}/staff-salary-task/data/get-salary-bill-cycle?accountMonth=${accountMonth}&tenantGuid=${tenantGuid}`,
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.billCycleListArr = res.data.data || [];
            // if(self.billCycleListArr && self.billCycleListArr.length > 0){
            //   self.billCycleListArr.forEach((i,index)=>{
            //     if(!i){
            //       self.billCycleListArr[index] = '全部';
            //     }
            //   })
            // }
            console.log('billCycleListArr',self.billCycleListArr);
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //获取任务
    getTaskList(isDefault) {
      let self = this;
      if (!self.operationForm.tenantGuid || !self.operationForm.accountMonth) return;
      let taskGuidList = [];
      if (this.newServiceTenantReportList.length && this.operationForm.newServiceOperationReportGuids.length) {
        this.newServiceTenantReportList.forEach(item => {
          if (this.operationForm.newServiceOperationReportGuids.indexOf(item.guid) > -1) {
            taskGuidList = taskGuidList.concat(item.taskGuidList)
          }
        })
      }
      let query = {
        taskGuidList,
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.operationForm.tenantGuid,
        organisationInfo: self.operationForm.organisationGuid,
        isService: 'Y',
        payState: '未结算',
        state: ['已派发', '待上传', '待考核', '待结算'],
        accountMonth: self.operationForm.accountMonth,
        serviceTenantGuid:localStorage.guid,
        curTenantGuid: localStorage.guid,
        serviceTenantGuidList: [],
        taskBelongCategory:1
      };
      if (this.showServiceProvider && this.operationForm.isChangeService == 'Y') {
        query.serviceTenantGuidList = this.operationForm.serviceTenantGuidList || [];
        delete query.serviceTenantGuid;
      }
      query.accountMonth = query.accountMonth.replace('-','');
      self.api.postJson(`/${serverConfig.msSalesPerformService}/task/data/get-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data && res.data.data.records) {
            self.taskList = res.data.data.records;
            // 是三方接包服务商
            if (self.isThirdPartyContractor) {
              self.taskList = self.taskList?.map(item => {
                return {
                  ...item,
                  taskTitle: item.taskTitleOrganisation
                };
              });
            };
            if (isDefault && self.taskList && self.taskList.length) {
              let guids = [];
              self.taskList.forEach(item => {
                guids.push(item.guid)
              })
              this.operationForm.taskGuidList = guids;
            }
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //获取平台任务
    getPlatTaskList() {
      let self = this;
      
      if(!self.operationForm.tenantGuid || self.operationForm.isPlatformTask!='Y'){
        // self.$message.error('请先选择信息')
        return
      }
      let tenantGuid= self.operationForm.tenantGuid
      
      self.api.get(`/${serverConfig.msSalesPerformService}/platform-task/get-operation-report-task?tenantGuid=${tenantGuid}`).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if (res.data.data ) {
            self.platTaskList = res.data.data;
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
.el-col-6,
.el-col-9 {
  display: flex;
  /* margin-bottom: 10px; */
}
.ipt-sty {
  flex: 1;
}
/deep/ .el-input__prefix {
  top: -4px !important;
}
a.txt-color + a.txt-color::before {
  content: '|';
  display: inline-block;
}
.flow-dialog {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}
.flow-dialog .flow-item {
  width: 90%;
  font-weight: bold;
  width: 200px;
  padding: 25px 0;
  text-align: center;
  border: 1px solid rgba(235, 235, 235, 1);
  border-radius: 4px;
  cursor: pointer;
}
.flow-dialog .flow-item:hover {
  color: #fff;
  background: #4fa1a4;
}
.flow-item-active {
  color: #fff;
  background: #4fa1a4;
}
.flow-dialog-title {
  position: relative;
  text-align: left;
  margin-top: 0;
}
.flow-dialog-title .flow-dialog-line {
  position: absolute;
  top: -3px;
  display: inline-block;
  width: 4px;
  height: 24px;
  background: #4fa1a4;
}
.flow-dialog-title .flow-dialog-txt {
  display: inline-block;
  padding-left: 15px;
}
.search-area-div{
  width: 90px;
  text-align: right;
}
.tab-wrap {
  background: #fff;

}

/deep/ .el-tabs__nav {
  margin-left: 10px;
}
.report-file-upload {
  width: 400px;
}
.report-file-upload /deep/ .el-upload-list {
  width: 100%;
}
.report-file-upload /deep/ .el-upload-list__item-name {
  white-space: inherit;
}
.file-operate {
  display: flex;
  align-items: center;
  width: 100%;
}
.file-name {
  color: #212121;
  margin-left: 4px;
  margin-right: 4px;
  flex: 1;
  min-width: 0;
}
.file-preview {
  margin-left: 10px;
  flex-shrink: 0;
  cursor: pointer;
  text-decoration: underline;
  color: #4fa1a4;
}
.report-upload-progress {
  width: 400px;
  margin-top: 8px;
}
.report-upload-progress-text {
  margin: 0 0 8px;
  font-size: 12px;
  color: #606266;
}
</style>
